import { render, staticRenderFns } from "./QRIssue.vue?vue&type=template&id=2d0857e2"
import script from "./QRIssue.vue?vue&type=script&lang=js"
export * from "./QRIssue.vue?vue&type=script&lang=js"
import style0 from "./QRIssue.vue?vue&type=style&index=0&id=2d0857e2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports